/**
 * 只读详情抽屉：用于只读详情展示（写操作用 EditDialog）。
 * 覆盖 admin-web-shell:SC-16。
 */
import { Drawer, type DrawerProps } from 'antd';
import type { ReactNode } from 'react';

export interface DetailDrawerProps extends Omit<DrawerProps, 'children'> {
  /** 详情内容 */
  children: ReactNode;
}

export function DetailDrawer({ children, ...rest }: DetailDrawerProps) {
  return <Drawer {...rest}>{children}</Drawer>;
}
